function getEnvVariable(suffix) {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  const varName = `REACT_APP_${suffix}_${env}`;
  return process.env[varName];
}

const awsExports = {
  REGION: 'eu-central-1',
  API_URL: getEnvVariable('API_URL'),
  GET_SANDBOX_API_URL: getEnvVariable('GET_SANDBOX_API_URL'),
  USER_PREFERENCES_API_URL: getEnvVariable('USER_PREFERENCES_API_URL'),
  CERTIFICATES_API_URL: getEnvVariable('CERTIFICATES_API_URL'),
  MODULE_APP_SYNCH_URL: getEnvVariable('MODULE_APP_SYNCH_URL'),
  USER_POOL_ID: getEnvVariable('USER_POOL_ID'),
  USER_POOL_APP_CLIENT_ID: getEnvVariable('USER_POOL_APP_CLIENT_ID'),
  MATERIAL_S3_BUCKET: getEnvVariable('MATERIAL_S3_BUCKET'),
  PRIVATE_PACKAGES: getEnvVariable('PRIVATE_PACKAGES'),
  PRIVATE_PACKAGES_API_KEY: getEnvVariable('PRIVATE_PACKAGES_API_KEY'),
  SEARCH_API: getEnvVariable('SEARCH_API'),
  SEARCH_API_KEY: getEnvVariable('SEARCH_API_KEY'),
  BLOG_S3_BUCKET: getEnvVariable('BLOG_S3_BUCKET'),
  NEWS_S3_BUCKET: getEnvVariable('NEWS_S3_BUCKET'),
  GAME_SCORE: getEnvVariable('GAME_SCORE'),
  GAME_STATUS: getEnvVariable('GAME_STATUS'),
  MODULE_API_KEY: getEnvVariable('MODULE_API_KEY'),
  PRICE: 70,
  ADVANCED_PRICE: 80,
  LAB_PRICE: 100,
  DISCOUNT: 1,
  // Epic 17 (E17-D4): the test environment (mod, in sn-test) has no lab platform, so the
  // sandbox, the IDE and lab completion are not offered there.
  LAB_PLATFORM: (process.env.REACT_APP_ENV || process.env.NODE_ENV) !== 'test',
};

export default awsExports;
